<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('creditnotes')">Credit Notes</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-6xl">

      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <text-input v-model="contactList.id" :error="form.errors.contact_id" class="pr-6 pb-8 w-full lg:w-1/2" v-if="contactList.id < 1" />
            <text-input v-model="contactList.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Contact Email" readonly="1" />
            <!-- <select-input v-if="$page.props.auth.user.customer_id == 0" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer" required >
              <option :value="null" />
              <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
            </select-input> -->
            <text-input v-if="$page.props.auth.user.owner" v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full lg:w-1/2" label="Description" required />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.invoice_no_ref" :error="form.errors.invoice_no_ref" class="pr-6 pb-8 w-full lg:w-1/2" label="Invoice No. Ref." required />
            <text-input v-if="$page.props.auth.user.owner" v-model="form.credit_amount" :error="form.errors.credit_amount" class="pr-6 pb-8 w-full lg:w-1/2" label="Credit Amount (EURO)" type="number" step="0.0001" required />
            
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Credit Note</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Credit Note' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
  },
  layout: Layout,
  props: {
    contacts: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        contact_id: null,
        description: null,
        invoice_no_ref: null,
        credit_amount: null
      }),
      contactList: this.contacts
    }
  },
mounted(){
  // console.log(this.contacts)
},
  methods: {
    store() {
      // console.log(this.form);
      if(this.form.description == null || this.form.invoice_no_ref == null || this.form.credit_amount == null){
        alert('Please provide all details.')
      }else{
        this.form.contact_id = this.contactList.id
        // console.log(this.form)
        this.form.post('/creditnotes')
      }

    }
  },
}
</script>
